import { LANG } from '@/const/Lang';
import enLocale from 'element-ui/lib/locale/lang/en';
import koLocale from 'element-ui/lib/locale/lang/ko';
import zhCNLocale from 'element-ui/lib/locale/lang/zh-CN';
import zhTWLocale from 'element-ui/lib/locale/lang/zh-TW';
import thLocale from 'element-ui/lib/locale/lang/th';
import moment from 'moment';

export default class MomentLang {
  static setMomentLang(langCode) {
    if (langCode === LANG.ja) {
      moment.updateLocale(LANG.ja, {
        weekdaysShort: ['日', '月', '火', '水', '木', '金', '土'],
      });
    }
    if (langCode === LANG.en) {
      moment.updateLocale(LANG.en, {
        weekdaysShort: [enLocale.el.datepicker.weeks.sun, enLocale.el.datepicker.weeks.mon, enLocale.el.datepicker.weeks.tue, enLocale.el.datepicker.weeks.wed, enLocale.el.datepicker.weeks.thu, enLocale.el.datepicker.weeks.fri, enLocale.el.datepicker.weeks.sat],
      });
    }
    if (langCode === LANG.zhTW) {
      moment.updateLocale(LANG.zhTW, {
        weekdaysShort: [zhTWLocale.el.datepicker.weeks.sun, zhTWLocale.el.datepicker.weeks.mon, zhTWLocale.el.datepicker.weeks.tue, zhTWLocale.el.datepicker.weeks.wed, zhTWLocale.el.datepicker.weeks.thu, zhTWLocale.el.datepicker.weeks.fri, zhTWLocale.el.datepicker.weeks.sat],
      });
    }
    if (langCode === LANG.zhCN) {
      moment.updateLocale(LANG.zhCN, {
        weekdaysShort: [zhCNLocale.el.datepicker.weeks.sun, zhCNLocale.el.datepicker.weeks.mon, zhCNLocale.el.datepicker.weeks.tue, zhCNLocale.el.datepicker.weeks.wed, zhCNLocale.el.datepicker.weeks.thu, zhCNLocale.el.datepicker.weeks.fri, zhCNLocale.el.datepicker.weeks.sat],
      });
    }
    if (langCode === LANG.ko) {
      moment.updateLocale(LANG.ko, {
        weekdaysShort: [koLocale.el.datepicker.weeks.sun, koLocale.el.datepicker.weeks.mon, koLocale.el.datepicker.weeks.tue, koLocale.el.datepicker.weeks.wed, koLocale.el.datepicker.weeks.thu, koLocale.el.datepicker.weeks.fri, koLocale.el.datepicker.weeks.sat],
      });
    }
    if (langCode === LANG.th) {
      moment.updateLocale(LANG.th, {
        weekdaysShort: [thLocale.el.datepicker.weeks.sun, thLocale.el.datepicker.weeks.mon, thLocale.el.datepicker.weeks.tue, thLocale.el.datepicker.weeks.wed, thLocale.el.datepicker.weeks.thu, thLocale.el.datepicker.weeks.fri, thLocale.el.datepicker.weeks.sat],
      });
    }
  }
}
